import './style.css';

// Import game (pure Three.js with Howler.js for audio)
import './game/NeedleGame';

console.log('🎂 Gimme My Cake - Loading...');
